// extracted by mini-css-extract-plugin
export var container = "_gt-0";
export var icon = "_gt-1";
export var text = "_gt-2";